@if (options()) {
  @if (options().label) {
    <label
      [id]="options().label?.id"
      [for]="!invalidMessage && options().id"
      [class]="'form-label ' + (options().label?.class || '')"
    >
      {{ translations.labels[options().label?.text || 'label'] || options().label?.text }}
      @if (options().required) {
        <span class="required">*</span>
      }
    </label>
  }
  @if (options().formGroup && options().formControlName && !options().formControl) {
    <span [formGroup]="options().formGroup!">
      <input
        #el
        [id]="options().id"
        [attr.name]="options().name"
        [type]="options().type"
        [attr.inputmode]="options().mode"
        [attr.pattern]="options().pattern"
        [class]="'form-control ncp-input ' + (options().inputClass || '')"
        [placeholder]="translations.placeholders[options().placeholder || 'default'] || options().placeholder"
        [formControlName]="options().formControlName!"
        (keydown)="onKeyDown($event, el.value)"
        (keyup)="onKeyUp($event, el.value, el)"
        (input)="onInput($any($event).target, $event)"
        (blur)="onBlur(el.value)"
        [value]="options().value"
        [autocomplete]="options().autocomplete"
        [min]="options().min"
        [max]="options().max"
        [step]="options().step"
      />
    </span>
  } @else if (!options().formGroup && !options().formControlName && options().formControl) {
    <input
      #el
      [id]="options().id"
      [attr.name]="options().name"
      [type]="options().type"
      [attr.inputmode]="options().mode"
      [attr.pattern]="options().pattern"
      [class]="'form-control ncp-input ' + (options().inputClass || '')"
      [placeholder]="translations.placeholders[options().placeholder || 'default']"
      [formControl]="options().formControl!"
      (keydown)="onKeyDown($event, el.value)"
      (keyup)="onKeyUp($event, el.value, el)"
      (input)="onInput($any($event).target, $event)"
      (blur)="onBlur(el.value)"
      [value]="options().value"
      [autocomplete]="options().autocomplete"
      [min]="options().min"
      [max]="options().max"
      [step]="options().step"
    />
  } @else if (!options().formGroup && !options().formControlName && !options().formControl) {
    <input
      #el
      [id]="options().id"
      [attr.name]="options().name"
      [type]="options().type"
      [attr.inputmode]="options().mode"
      [attr.pattern]="options().pattern"
      [class]="'form-control ncp-input ' + (options().inputClass || '')"
      [placeholder]="translations.placeholders[options().placeholder || 'default']"
      (keydown)="onKeyDown($event, el.value)"
      (keyup)="onKeyUp($event, el.value, el)"
      (input)="onInput($any($event).target, $event)"
      (blur)="onBlur(el.value)"
      [value]="options().value"
      [autocomplete]="options().autocomplete"
      [min]="options().min"
      [max]="options().max"
      [step]="options().step"
    />
  } @else if (options().formGroup && options().formControlName && options().formControl) {
    <div
      class="alert alert-danger"
      role="alert"
    >
      <span class="badge rounded-pill bg-secondary">Developer</span>: Cannot set FormControl and the
      combination FormGroup - FormControlName at the same time
    </div>
  } @else if (options().formGroup && !options().formControlName && options().formControl) {
    <div
      class="alert alert-danger"
      role="alert"
    >
      <span class="badge rounded-pill bg-secondary">Developer</span>: Cannot set FormControl and
      FormGroup at the same time
    </div>
  } @else if (!options().formGroup && options().formControlName && options().formControl) {
    <div
      class="alert alert-danger"
      role="alert"
    >
      <span class="badge rounded-pill bg-secondary">Developer</span>: Cannot set FormControl and
      FormControlName at the same time
    </div>
  } @else if (options().formGroup && !options().formControlName && !options().formControl) {
    <div
      class="alert alert-danger"
      role="alert"
    >
      <span class="badge rounded-pill bg-secondary">Developer</span>: Cannot set FormGroup without
      setting FormControlName too
    </div>
  } @else if (!options().formGroup && options().formControlName && !options().formControl) {
    <div
      class="alert alert-danger"
      role="alert"
    >
      <span class="badge rounded-pill bg-secondary">Developer</span>: Cannot set FormControlName
      without setting FormGroup too
    </div>
  }
  <div class="invalid-feedback">
    {{ invalidMessage }}
  </div>
} @else {
  <div
    class="alert alert-danger"
    role="alert"
  >
    <span class="badge rounded-pill bg-secondary">Developer</span>: Cannot instantiate input without
    options() set
  </div>
}
